<template>
  <div>
    <h1>
      Front end: {{ frontEndVersion }} <br />
      Back end: {{ backEndVersion }}
    </h1>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Version",
  computed: {
    ...mapState("common", ["frontEndVersion", "backEndVersion"])
  },
  mounted() {
    this.$store.dispatch("common/getBackEndVersion");
  }
};
</script>

<style scoped lang="scss">
div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>
